import axios from 'axios';
import {
    EMERGENCY_ACCESS_REQUEST_REQUEST,
    EMERGENCY_ACCESS_REQUEST_SUCCESS,
    EMERGENCY_ACCESS_REQUEST_FAIL,
    EMERGENCY_ACCESS_REQUEST_RESET,
    EMERGENCY_ACCESS_VERIFY_REQUEST,
    EMERGENCY_ACCESS_VERIFY_SUCCESS,
    EMERGENCY_ACCESS_VERIFY_FAIL,
    EMERGENCY_ACCESS_PATIENT_REQUEST,
    EMERGENCY_ACCESS_PATIENT_SUCCESS,
    EMERGENCY_ACCESS_PATIENT_FAIL,
    EMERGENCY_ACCESS_HISTORY_REQUEST,
    EMERGENCY_ACCESS_HISTORY_SUCCESS,
    EMERGENCY_ACCESS_HISTORY_FAIL,
    EMERGENCY_ACCESS_REVOKE_REQUEST,
    EMERGENCY_ACCESS_REVOKE_SUCCESS,
    EMERGENCY_ACCESS_REVOKE_FAIL
} from '../constants/emergencyAccessConstants';

export const requestEmergencyAccess = (nhsNumber, reason) => async (dispatch, getState) => {
    try {
        dispatch({ type: EMERGENCY_ACCESS_REQUEST_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const { data } = await axios.post(
            '/api/v1/emergencyaccess/request',
            { patientNHSNumber: nhsNumber, reason },
            config
        );

        dispatch({
            type: EMERGENCY_ACCESS_REQUEST_SUCCESS,
            payload: data
        });

        return data;
    } catch (error) {
        dispatch({
            type: EMERGENCY_ACCESS_REQUEST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        });
        throw error;
    }
};

export const resetEmergencyAccessRequest = () => (dispatch) => {
    dispatch({ type: EMERGENCY_ACCESS_REQUEST_RESET });
};

export const verifyEmergencyAccessToken = (token) => async (dispatch) => {
    try {
        dispatch({ type: EMERGENCY_ACCESS_VERIFY_REQUEST });

        const { data } = await axios.get(`/api/v1/emergencyaccess/verify/${token}`);

        dispatch({
            type: EMERGENCY_ACCESS_VERIFY_SUCCESS,
            payload: data
        });

        return data;
    } catch (error) {
        dispatch({
            type: EMERGENCY_ACCESS_VERIFY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        });
        throw error;
    }
};

export const getPatientByToken = (token) => async (dispatch) => {
    try {
        dispatch({ type: EMERGENCY_ACCESS_PATIENT_REQUEST });

        const { data } = await axios.get(`/api/v1/emergencyaccess/${token}/patient`);

        dispatch({
            type: EMERGENCY_ACCESS_PATIENT_SUCCESS,
            payload: data
        });

        return data;
    } catch (error) {
        dispatch({
            type: EMERGENCY_ACCESS_PATIENT_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        });
        throw error;
    }
};

export const getEmergencyAccessHistory = (filters = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: EMERGENCY_ACCESS_HISTORY_REQUEST });

        const { userLogin: { userInfo } } = getState();
        const { page = 1, limit = 20, status, filter, query, dateFrom, dateTo } = filters;

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            },
            params: {
                page,
                limit,
                ...(status && status !== 'all' && { status }),
                ...(filter && { filter }),
                ...(query && { query }),
                ...(dateFrom && { dateFrom }),
                ...(dateTo && { dateTo }),
            }
        };

        const { data } = await axios.get('/api/v1/emergencyaccess/history', config);

        dispatch({
            type: EMERGENCY_ACCESS_HISTORY_SUCCESS,
            payload: data
        });

        return data;
    } catch (error) {
        dispatch({
            type: EMERGENCY_ACCESS_HISTORY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        });
        throw error;
    }
};

export const exportEmergencyAccessHistory = (filters = {}) => async (dispatch, getState) => {
    const { userLogin: { userInfo } } = getState();
    const { status, filter, query, dateFrom, dateTo } = filters;

    const response = await axios.get('/api/v1/emergencyaccess/history/export', {
        headers: {
            Authorization: `Bearer ${userInfo.token}`
        },
        params: {
            ...(status && status !== 'all' && { status }),
            ...(filter && { filter }),
            ...(query && { query }),
            ...(dateFrom && { dateFrom }),
            ...(dateTo && { dateTo }),
        },
        responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `emergency_access_history_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const revokeEmergencyAccessToken = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: EMERGENCY_ACCESS_REVOKE_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const { data } = await axios.delete(`/api/v1/emergencyaccess/${id}`, config);

        dispatch({
            type: EMERGENCY_ACCESS_REVOKE_SUCCESS,
            payload: id
        });

        return data;
    } catch (error) {
        dispatch({
            type: EMERGENCY_ACCESS_REVOKE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        });
        throw error;
    }
};



